// Apple Maps のリンク生成
// できるだけ誤検索を避けるため、lat/lon があればそれを優先
// なければ 「店名 + 市区町村 + 都道府県 + 住所 + 日本」で検索クエリを組み立て
export function buildAppleMapsLink(
  name?: string,
  location?: string,
  lat?: number,
  lon?: number,
  prefecture?: string,
  municipality?: string,
) {
  const isIOS = /iPad|iPhone|iPod/i.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 1);
  const base = isIOS ? 'maps://?' : 'https://maps.apple.com/?';

  // 緯度経度があればそれを目的地として使用（最も確実）
  if (typeof lat === 'number' && typeof lon === 'number' && !Number.isNaN(lat) && !Number.isNaN(lon)) {
    const daddr = `${lat},${lon}`;
    return `${base}daddr=${encodeURIComponent(daddr)}&saddr=Current+Location&dirflg=d`;
  }

  // テキスト検索: 店名 + 行政区画 + 住所 + 日本
  const parts = [name, municipality, prefecture, location, '日本'].filter((v) => !!v && String(v).trim().length > 0);
  const query = encodeURIComponent(parts.join(' ').trim());
  return `${base}daddr=${query}&saddr=Current+Location&dirflg=d`;
}
